import "./styles/global.css";
import { Suspense } from "react";
// Keep the eager route entry. The lazy Generouted entry has broken packaged
// Capacitor bundles; desktop isolation happens inside the shared app instead.
import { Routes } from "@generouted/react-router";
import { createRoot } from "react-dom/client";
import { hydrateApp, telemetry, useAppStore } from "@/controller";
import { initializeLocales } from "@/locales";
import { setGlobalDictationLocaleAsync } from "@/models/useGlobalDictation";

const App = () => {
  return (
    <Suspense>
      <Routes />
    </Suspense>
  );
};

const _start = async () => {
  telemetry.start();
  const localeInitialization = initializeLocales({
    onFailure: (failure) => telemetry.track("locale.loadFailed", failure),
  });
  for (const retryDelayMs of [0, 100, 500]) {
    if (retryDelayMs > 0) {
      await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
    }
    if (await hydrateApp()) {
      break;
    }
  }
  const activeLocale = await localeInitialization;
  try {
    await setGlobalDictationLocaleAsync(activeLocale.language);
  } catch {
    console.error("[GlobalDictation] Failed to sync app locale");
  }
  const userId = useAppStore.getState().userData?.id;
  if (userId) telemetry.identify({ userId });
  createRoot(document.getElementById("root")!).render(<App />);
};

void _start();
